export const curaboxBaseConfig = {
  storyblok: {
    settingsPath: 'product-domains/curabox/settings/de',
    pagesPath: 'product-domains/curabox/www/de',
  },
  errorPage: 'curabox',
  redirects: 'curabox',
  redirectWww: true,
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty strings should fall back as well
  etUrl: process.env.ET_URL || '/et/get-session-data',
} as const

export const pflegeServicesBaseConfig = {
  path: '/services',
  storyblok: {
    settingsPath: 'product-domains/pflege-de-services/settings/de',
    pagesPath: 'product-domains/pflege-de-services/www/de',
  },
  errorPage: 'basic',
  etUrl: '/services/et/get-session-data',
} as const
